import { DiningOptionBehavior } from 'src/apollo/onlineOrdering'
import { useFormatMoney } from 'src/lib/js/hooks/useFormatPrice'
import { t } from 'src/translations'

import {
  isFreeDeliveryThresholdReached,
  useAmountNeededMessage,
  useAppliedFreeDelivery,
  useFreeDeliveryOffer
} from 'public/components/default_template/offers/useFreeDeliveryOffer'
import { useCart } from 'public/components/online_ordering/CartContext'
import { useCustomer } from 'public/components/online_ordering/CustomerContextCommon'

export enum FreeDeliveryCheckoutPrompt {
  None = 'None',
  SignIn = 'SignIn',
  AddItems = 'AddItems'
}

// Shared with the subcopy above the Toast sign-in button so the two cannot
// disagree.
export const useFreeDeliveryCheckout = () => {
  const offer = useFreeDeliveryOffer()
  const { isApplied } = useAppliedFreeDelivery()
  const { cart } = useCart()
  const { isLoggedIn, loadingCustomer } = useCustomer()
  const formatMoney = useFormatMoney()
  const amountNeededMessage = useAmountNeededMessage(offer)

  const none = { prompt: FreeDeliveryCheckoutPrompt.None, message: '' }

  // The cart, not FulfillmentContext: it carries the behavior the order will
  // actually be placed with.
  const isDelivery =
    cart?.diningOptionBehavior === DiningOptionBehavior.Delivery

  if (!offer || !isDelivery || isApplied) {
    return none
  }

  if (!(isLoggedIn || loadingCustomer)) {
    return {
      prompt: FreeDeliveryCheckoutPrompt.SignIn,
      message: t('free-delivery-checkout.sign-in-for-free-delivery', {
        amount: formatMoney(offer.minPurchaseAmount)
      })
    }
  }

  // Over the minimum but not applied yet: waiting on the backend, not the guest.
  if (isFreeDeliveryThresholdReached(offer)) {
    return none
  }

  return {
    prompt: FreeDeliveryCheckoutPrompt.AddItems,
    message: amountNeededMessage
  }
}
